<template>
  <a-modal
    :visible="visible"
    :title="hasEvent ? '修改事件' : '添加新的事件'"
    :okText="hasEvent ? '保存' : '添加'"
    cancelText="取消"
    @cancel="$emit('cancel')"
    @keyup.enter="onSubmit"
    @ok="onSubmit"
  >
    <a-form-model layout="vertical" ref="form" :model="form" :rules="rules">
      <a-form-model-item label="事件名" prop="name">
        <a-input v-model="form.name" @change="onChange" @pressEnter="onSubmit">
          <a-dropdown
            slot="addonBefore"
            :trigger="['click']"
            v-model="setIconVisible"
          >
            <a-tooltip title="设置图标">
              <div class="setIcon">
                {{ form.icon }}
              </div>
            </a-tooltip>
            <VEmojiPicker
              slot="overlay"
              @select="selectEmoji"
              :i18n="i18n"
              :continuousList="true"
            />
          </a-dropdown>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="缩写方式">
        <a-select label-in-value v-model="abbrType" @change="onChange">
          <a-select-option value="name">
            同名称
          </a-select-option>
          <a-select-option value="pinyin">
            拼音
          </a-select-option>
          <a-select-option value="initial">
            拼音首字母
          </a-select-option>
          <a-select-option value="user-defined">
            自定义
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="缩写" prop="abbr">
        <a-input
          v-model="form.abbr"
          :disabled="disabledInput"
          @pressEnter="onSubmit"
        />
      </a-form-model-item>
      <a-form-model-item label="描述" prop="description">
        <a-input v-model="form.description" @pressEnter="onSubmit" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VEmojiPicker from "v-emoji-picker";
//Event数据结构
// id: (...)
// name: (...)
// abbr: (...)
// description: (...)
// active: (...)
// star: (...)
export default {
  props: ["visible", "event"],
  components: {
    VEmojiPicker
  },
  data() {
    return {
      abbrType: { key: "initial" },
      disabledInput: true,
      setIconVisible: false,
      form: {
        name: "",
        abbr: "",
        description: "",
        icon: "🎯"
      },
      rules: {
        name: [
          { required: true, message: "请输入事件名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              for (let id in this.events) {
                if (!this.hasEvent && this.events[id].name === value)
                  callback("已有相同名字的事件");
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      i18n: {
        search: "搜索表情",
        categories: {
          Activity: "运动",
          Flags: "旗帜",
          Foods: "食物",
          Frequently: "最近",
          Objects: "物品",
          Nature: "自然",
          Peoples: "人物",
          Symbols: "图标",
          Places: "其他"
        }
      }
    };
  },
  computed: {
    hasEvent() {
      return this.event && Object.keys(this.event).length !== 0;
    },
    ...mapGetters(["events"])
  },
  mounted() {
    if (this.hasEvent) {
      const { name, abbr, description, icon } = this.event;
      this.form = { name, abbr, description, icon };
      this.disabledInput = false;
      this.abbrType = { key: "user-defined" };
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.hasEvent) {
            this.updatedEvent({ id: this.event.id, ...this.form });
            this.$message.success("已保存");
          } else {
            this.createEvent(this.form);
            this.$message.success("添加完成");
          }

          this.$emit("create");
          this.$refs.form.resetFields();
        } else {
          this.$message.error("数据错误");

          return false;
        }
      });
    },
    async onChange() {
      const type = this.abbrType.key;
      switch (type) {
        case "name":
          this.disabledInput = true;
          this.form.abbr = this.form.name;

          break;
        case "pinyin":
          this.form.abbr = await this.getPinyin(this.form.name);
          this.disabledInput = true;

          break;
        case "initial":
          this.disabledInput = true;
          this.form.abbr = await this.getInitial(this.form.name);

          break;
        case "user-defined":
          this.disabledInput = false;
          break;
      }
    },
    selectEmoji(emoji) {
      this.form.icon = emoji.data;
      this.setIconVisible = false;
      console.log(emoji);
    },
    ...mapActions(["createEvent", "updatedEvent", "getInitial", "getPinyin"])
  }
};
</script>
<style>
.setIcon {
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  font-size: 1.8rem;
}
</style>
